/* eslint no-unused-vars:0 */
import axios from 'axios';
import {incomePlanAxios} from "@/axios";
import {
    PERFORMANCE_BENCHMARK_OPTIONS_SET,
    PERFORMANCE_BENCHMARK_OPTIONS_UPDATED,
    PERFORMANCE_SET
} from './constant';

export default {
    fetchHousehold({commit}, householdId) {
        return incomePlanAxios
            .get(process.env.VUE_APP_BASE_URL + '/api/households/'+ householdId)
            .then(r => r.data.data)
            .then(response => {
                commit('setHousehold', response);
            });
    },

    fetchHouseholdAccountData({dispatch}, householdId) {
        return Promise.all([
            dispatch('asset/loadAssets', {householdId}, {root: true}),
            dispatch('lifeInsurance/loadLifeInsurances', {householdId}, {root: true}),
            dispatch('liability/loadLiabilities', {householdId}, {root: true}),
            dispatch('property/loadProperties', {householdId}, {root: true}),
            dispatch('accounts/loadAccounts', null, {root: true}),
        ]);
    },

    /**
     * Reset income planner variables
     * @param commit
     * @param rootState
     * @param householdId Old clone household id
     * @returns {Promise<*>}
     */
    resetVariables({commit, rootState}, householdId) {
        return incomePlanAxios.post(process.env.VUE_APP_BASE_URL + `/api/households/${householdId}/income-planner/variables/reset`)
    },

    fetchPerformance({commit, rootState}, cached= false) {
        return incomePlanAxios
            .get(process.env.VUE_APP_BASE_URL +
                '/api/households/' +
                rootState.auth.user.household_id +
                '/performance/twelve-months' +
                (cached ? '' : '?noCache=true'))
            .then(
                r => r.data.data
            ).then(
                data => {
                    if (cached) {
                        commit(PERFORMANCE_SET, data.performance);
                    }
                }
            );
    },

    fetchPerformanceOptions({commit, rootState}) {
       return incomePlanAxios.get(
           process.env.VUE_APP_BASE_URL +
           '/api/household/' +
           rootState.auth.user.household_id +
           '/export-options/performance_history_reports'
       ).then(
           r => r.data.data
       ).then(
           data => {
               commit(PERFORMANCE_BENCHMARK_OPTIONS_SET, data)
           }
       )
    },

    updatePerformanceOptions({commit, rootState}, {payload}) {
        return incomePlanAxios.post(
            process.env.VUE_APP_BASE_URL +
            '/api/household/' +
            rootState.auth.user.household_id +
            '/export-options',
            payload
        ).then(
            r => r.data.data
        ). then(
            data => {
                commit(PERFORMANCE_BENCHMARK_OPTIONS_UPDATED, {optionId: payload.id, enabled: payload.enabled})
            }
        )
    },

    fetchIntegrationStatus({commit, rootState}) {
        return incomePlanAxios
            .get(process.env.VUE_APP_BASE_URL + '/api/households/'+ rootState.auth.user.household_id + '/integration-status')
            .then(r => r.data.data)
            .then(response => {
                commit('INTEGRATION_STATUS_SET', response);
            });
    },

    fetchPositions({commit}, householdId) {
        axios
            .get(process.env.VUE_APP_BASE_URL + '/api/households/'+ householdId +'/positions')
            .then(
                r => r.data.data
             ). then(
                data => {
                    commit('setPositions', data.positions)
            }
        )
    },

}
